import application_settings from '../applicationSettings';
import Event from './Event';

class GetCategroyByProduct extends Event {
    eventName = 'oms_getCategroyByProduct';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get settings
     * 
     * @param {string} data.client_id -  id given for client
     * @param {string} data.product_id -  product id
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        
        // request data
        data.endPoint = application_settings.endPoints.getCategoryByProduct;
        data.data = {
            client_id: clientId,
            product_id: data.product_id,
        };
    
        this.sendRequest(data, function (response) {
            if (response) {

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
        
    }
}

export default GetCategroyByProduct;